'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _Conversation$propTyp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _Messages = require('./Messages');

var _Messages2 = _interopRequireDefault(_Messages);

var _Typing = require('./Typing');

var _Typing2 = _interopRequireDefault(_Typing);

var _Choices = require('./Choices');

var _Choices2 = _interopRequireDefault(_Choices);

var _Util = require('components/Util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Conversation = function (_React$Component) {
  (0, _inherits3.default)(Conversation, _React$Component);

  function Conversation(props) {
    (0, _classCallCheck3.default)(this, Conversation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Conversation.__proto__ || (0, _getPrototypeOf2.default)(Conversation)).call(this, props));

    _this.countMessagesInBlocks = function (howManyBlocks) {
      var acum = 0;
      var limit = _this.state.conversationIndex + howManyBlocks;
      for (var i = _this.state.conversationIndex; i < limit; i++) {
        acum += _this.state.messagesToBeDisplayed[i].length;
      }
      return acum;
    };

    _this.skipMessagesBlock = function (howManyBlocks) {
      //Actualizamos progreso para que se refleje en la barra inferior
      var howManyMessages = _this.countMessagesInBlocks(howManyBlocks);
      _this.props.addProgress(howManyMessages);

      //Avanzamos el índice de conversación que apunta al bloque de mensajes actual y mostramos  bloque de mensajes, o bien establecemos la conversación como terminada
      _this.addConversationIndex(howManyBlocks, function () {
        if (_this.state.conversationIndex === _this.state.messagesToBeDisplayed.length) {
          _this.props.setConversationDone();
        } else {
          _this.showMessagesBlock();
        }
      });
    };

    _this.getMessagesLang = function (limit, newMessages) {
      var messages = [];
      var messagesToBe = [];
      var messagesChanged = 0;

      //Avanzamos por los bloques de mensajes
      for (var i = 0; i < newMessages.length; i++) {
        messagesToBe.push([]);
        //Avanzamos por los mensajes individuales
        for (var j = 0; j < newMessages[i].length; j++) {
          var item = newMessages[i][j];
          //Si no es un mensaje typing y estamos dentro del número de mensajes ya mostrados, lo metemos a messages
          if (item.type !== 'typing' && messagesChanged < limit) {
            messages.push(item);
            messagesChanged++;
          } else {
            if (messagesChanged >= limit) {
              messagesToBe[i].push(item);
            }
          }
        }
      }

      return [messages, messagesToBe];
    };

    _this.addConversationIndex = function (howManyBlocks, callback) {
      _this.setState({
        conversationIndex: _this.state.conversationIndex + howManyBlocks,
        messagesComing: false
      }, function () {
        callback();
      });
    };

    _this.showMessage = function () {
      var i = _this.state.conversationIndex;
      var messages = _this.state.messages;
      var messagesToBeDisplayed = _this.state.messagesToBeDisplayed.map(function (arr) {
        return arr.slice();
      });
      var reset = _this.state.reset;
      var messagesComing = _this.state.messagesComing;

      if (messagesToBeDisplayed[i][1] != undefined) {
        if (messagesToBeDisplayed[i][1].showMedia) {
          var numberOf = messagesToBeDisplayed[i][1].messageId - 1;

          if (document.getElementsByClassName('point').length) {
            document.getElementsByClassName('point')[numberOf].setAttribute("data-showing", "true");
          }
          //$('.point')[numberOf].setAttribute("data-showing", "true");
        }
      }

      if (messagesToBeDisplayed[i].length > 0) {
        var message = messagesToBeDisplayed[i].shift();
        var isTyping = _this.state.isTyping;
        var isChoice = _this.state.isChoice;
        var inbound = _this.state.inbound;
        var choices = [];
        messagesComing = true;

        if (message.type === 'typing') {
          isTyping = true;
          isChoice = false;
          inbound = message.inbound;
        } else if (message.type === 'choice') {
          isChoice = true;
          isTyping = false;
          choices = message.choices.slice();
        } else {
          messages.push(message);
          isTyping = false;
          isChoice = false;
        }

        var onDisplay = undefined;
        if (message.onDisplay) {
          onDisplay = message.onDisplay.bind(null, message.id);
        } else {
          onDisplay = _this.scrollToBottom.bind(null, _this.props.elemToScroll);
        }
        _this.setState((0, _extends3.default)({}, _this.state, {
          messages: messages,
          messagesToBeDisplayed: messagesToBeDisplayed,
          isTyping: isTyping,
          isChoice: isChoice,
          choices: choices,
          messagesComing: messagesComing,
          inbound: inbound,
          reset: reset
        }), onDisplay);

        _this.props.addProgress();
        _this.timeoutId = setTimeout(_this.showMessage, message.duration || 800);
      } else {
        _this.addConversationIndex(1, function () {
          if (_this.state.conversationIndex === _this.state.messagesToBeDisplayed.length) {
            _this.props.setConversationDone();
          }
        });
      }
    };

    _this.selectChoice = function (choiceSelected, ev) {
      ev.preventDefault();

      _this.setState({
        isChoice: false
      }, function () {
        //Construimos mensaje a mostrar en función de lo seleccionado
        var messageChoice = {
          message: choiceSelected.messageToShow || choiceSelected.message,
          author: choiceSelected.author,
          inbound: false
        };
        var messages = _this.state.messages;
        messages.push(messageChoice);
        _this.scrollToBottom(_this.props.elemToScroll);

        _this.setState((0, _extends3.default)({}, _this.state, {
          messages: messages
        }));
        _this.timeoutId = setTimeout(function () {
          //Si la opción elegida es un link, entonces vamos a él
          if (choiceSelected.link !== undefined) {
            var url = '/' + _this.context.project + '/' + _this.props.currentLanguage + '/' + choiceSelected.link;
            _this.context.router.push(url);
          } else {
            if (choiceSelected.skipMessageBlocks === 0) {
              _this.showMessagesBlock();
            } else {
              _this.skipMessagesBlock(choiceSelected.skipMessageBlocks);
            }
          }
        }, 800);
      });
    };

    _this.state = {
      startingDelay: props.delay || 1000,
      conversationIndex: 0,
      messages: [],
      messagesToBeDisplayed: props.messages.slice(),
      originalMessages: props.messages.slice(),
      isTyping: false,
      isChoice: false,
      choices: [],
      messagesComing: false,
      inbound: true,
      reset: false,
      yDown: null
    };

    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.showMessagesBlock = _this.showMessagesBlock.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Conversation, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.timeoutId = setTimeout(this.showMessage, this.state.startingDelay);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutId);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.props.currentLanguage !== newProps.currentLanguage) {
        var actualMessagesLength = this.state.messages.length;
        var newMessages = this.props.messages.map(function (arr) {
          return arr.slice();
        });
        var newLangMessages = this.getMessagesLang(actualMessagesLength, newMessages);

        this.setState({
          messages: newLangMessages[0],
          messagesToBeDisplayed: newLangMessages[1]
        });
      }

      //estamos en el componente Mobile y hemos cambiado de idioma y cambiamos los mensajes q ya han salido por los q nos vienen
      if (this.props.mobile) {

        if (this.state.messages.length > 0) {

          if (this.state.messages[0] != this.props.messages[0][1]) {

            window.location.reload();

            // let stateCopy = Object.assign({}, this.state);              

            // //Modificamos los ya mostrados en pantalla
            // let numMessagesShowed = this.state.messages.length;
            // for(let i = 0 ; i<numMessagesShowed; i++){
            //   stateCopy.messages[i] =  this.props.messages[i][1];
            // }

            // //stateCopy.conversationIndex = 0;
            // let numMessagesToShow = this.props.messages.length;
            // for(let x = 0 ; x<numMessagesToShow; x++){
            //   stateCopy.messagesToBeDisplayed[x] =  this.props.messages[x];
            // }
            // this.setState(stateCopy);      
          }
        }
      }
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(e) {
      this.setState({
        yDown: e.touches[0].clientY
      });
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(e) {
      var yUp = e.touches[0].clientY;

      var yDiff = this.state.yDown - yUp;
      if (yDiff < 0) {
        if (this.state.messagesComing) e.preventDefault();
      } else {
        this.showMessagesBlock();
      }

      this.setState({
        yDown: null
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll(e) {
      var evt = window.event || e;
      var delta = evt.detail ? evt.detail * -120 : evt.wheelDelta;

      //if (delta === -120) {
      if (delta < 0) {
        this.showMessagesBlock();
      } else if (delta >= 0) {
        $("#scrollContainer").stop();
      }
    }
  }, {
    key: 'showMessagesBlock',
    value: function showMessagesBlock() {
      if (!this.props.conversationDone && !this.state.messagesComing && !this.state.isChoice) {
        this.showMessage();
      }

      // if (document.getElementsByClassName('swipeMobile')[0]){
      //   if ( document.getElementsByClassName('swipeMobile')[0].classList.contains('hide') ){
      //     document.getElementsByClassName('swipeMobile')[0].remove('hide')
      //   }  
      //     //document.getElementsByClassName('swipeMobile')[0].remove('hide')
      // }
    }
  }, {
    key: 'scrollToBottom',
    value: function scrollToBottom() {
      var elemToScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "#scrollContainer";

      $(elemToScroll).animate({ scrollTop: $(elemToScroll).prop("scrollHeight") }, 1000);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          isTyping = _state.isTyping,
          isChoice = _state.isChoice,
          inbound = _state.inbound;

      var isInbound = isTyping && inbound;
      var isOutbound = isTyping && !inbound;

      var typingClass = (0, _classnames2.default)({
        'inbound': isInbound,
        'outbound': isOutbound,
        'noTyping': !isTyping
      });
      var choicesClass = (0, _classnames2.default)({
        'choices': true,
        'noChoices': !isChoice
      });
      return _react2.default.createElement(
        _Util.ScrollWrapper,
        { onWindowScroll: this.handleScroll, onWheel: this.handleScroll, onTouchStart: this.handleTouchStart, onTouchMove: this.handleTouchMove },
        _react2.default.createElement(
          'div',
          { className: 'conversation' },
          _react2.default.createElement(
            'div',
            { className: 'wrapper', id: 'scrollContainer' },
            _react2.default.createElement(
              'div',
              { className: 'chat' },
              _react2.default.createElement(
                'div',
                { className: 'messages' },
                _react2.default.createElement(_Messages2.default, { key: this.state.reset, height: this.props.height, messages: this.state.messages, showMediaElement: this.props.showMediaElement, baseUrl: this.context.baseUrl })
              ),
              _react2.default.createElement(
                'div',
                { className: typingClass },
                isTyping && _react2.default.createElement(_Typing2.default, null)
              ),
              _react2.default.createElement(
                'div',
                { className: choicesClass },
                isChoice && _react2.default.createElement(_Choices2.default, { choices: this.state.choices, action: this.selectChoice, currentLanguage: this.props.currentLanguage })
              ),
              _react2.default.createElement(
                'div',
                { className: "goInteractive nextView " + this.props.caseId, onClick: this.props.nextFact },
                _react2.default.createElement(
                  'span',
                  null,
                  this.props.buttonGoInteractive
                ),
                _react2.default.createElement('i', { className: 'icon-arrowright' })
              )
            )
          )
        )
      );
    }
  }]);
  return Conversation;
}(_react2.default.Component);

Conversation.propTypes = (_Conversation$propTyp = {
  delay: _react.PropTypes.number,
  height: _react.PropTypes.number,
  messages: _react.PropTypes.arrayOf(_react.PropTypes.arrayOf(_react.PropTypes.shape({
    message: _react.PropTypes.string,
    src: _react.PropTypes.string,
    inbound: _react.PropTypes.bool.isRequired,
    avatar: _react.PropTypes.string,
    duration: _react.PropTypes.number,
    backgroundColor: _react.PropTypes.string,
    color: _react.PropTypes.string
  }))).isRequired,
  showMediaElement: _react.PropTypes.func,
  styles: _react.PropTypes.object,
  addProgress: _react.PropTypes.func
}, (0, _defineProperty3.default)(_Conversation$propTyp, 'showMediaElement', _react.PropTypes.func), (0, _defineProperty3.default)(_Conversation$propTyp, 'elemToScroll', _react.PropTypes.string), (0, _defineProperty3.default)(_Conversation$propTyp, 'currentLanguage', _react.PropTypes.string), (0, _defineProperty3.default)(_Conversation$propTyp, 'buttonGoInteractive', _react.PropTypes.string), (0, _defineProperty3.default)(_Conversation$propTyp, 'nextFact', _react.PropTypes.func), _Conversation$propTyp);

Conversation.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired,
  router: _react2.default.PropTypes.object.isRequired
};

exports.default = Conversation;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/Conversation.js
// module id = 788
// module chunks = 0